import { BROKER_AGREEMENT_ACCEPTED_KEY } from '../constants';
import { getCookie } from './cookies';
export var getAgreementAccepted = function getAgreementAccepted() {
  if (typeof document !== 'undefined') {
    return getCookie(BROKER_AGREEMENT_ACCEPTED_KEY) === 'true';
  }
  return false;
};